/******************************************************
 *                  Module map-iti
 ********************************************************/

"use strict";

angular.module("manager", ["services"]);

